<div class="container">
  @if (pageTitle() || breadcrumbBack()) {
    <div class="title-section">
      @if (breadcrumbBack(); as breadcrumb) {
        <nav class="breadcrumb" aria-label="Breadcrumb">
          <a [routerLink]="breadcrumb.backRoute" class="breadcrumb-back">
            <mat-icon>arrow_back</mat-icon>
            {{ breadcrumb.backLabel }}
          </a>
          @if (pageTitle()) {
            <span class="breadcrumb-separator">/</span>
            <span class="breadcrumb-current">{{ pageTitle() }}</span>
          }
        </nav>
      }

      @if (pageTitle()) {
        <h1 class="title">{{ pageTitle() }}</h1>
      }
    </div>
  }

  <div class="actions">
    <div class="profile" [matMenuTriggerFor]="profileMenu" #profileTrigger="matMenuTrigger">
      <button class="avatar-button icon-button" type="button">
        {{ avatarLetter() }}
      </button>

      <div class="name">
        <span class="username">{{ displayName() }}</span>
      </div>

      <mat-icon class="arrow">
        {{ profileTrigger.menuOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
      </mat-icon>
    </div>

    <mat-menu #profileMenu="matMenu" class="profile-menu">
      <div class="user-data">
        <div class="user-info">
          <button class="avatar-button icon-button" type="button">
            {{ avatarLetter() }}
          </button>

          <div class="name">
            <span class="username">{{ displayName() }}</span>
            @if (email()) {
              <span class="usermail">{{ email() }}</span>
            }
          </div>
        </div>

        <div class="user-actions">
          <!--
          <button type="button" mat-menu-item class="settings" (click)="openSettings()">
            <mat-icon>settings</mat-icon>
            <span class="text">Settings</span>
          </button>
        -->

          <button type="button" mat-menu-item class="logout" (click)="logout()">
            <mat-icon>input</mat-icon>
            <span class="text">Log Out</span>
          </button>
        </div>
      </div>
    </mat-menu>
  </div>
</div>
